(function($) {
// angular wrapper for uniform.js plugin
angular.module('components.uniform', [])
    .directive('uniform', function() {
        return {
            restrict: 'C', // directive is class-based
            link: function(scope, element, attrs) {
                element.uniform();

                scope.$watch(attrs.ngModel, function (newValue, oldValue) {
                   $.uniform.update(element);
                });

                if (angular.isDefined(attrs.value)) {
                    //console.log("Watching");
                    attrs.$observe("value", function(value) {
                        scope.$evalAsync(function() {
                            $.uniform.update(element);
                            //console.log("inside callback" + value);
                        });

                    });
                }
            }
        };
    });
})(jQuery);